/**
 * Constant for the Intercom chat id
 */
export type IIntercomAppId = string;

export const IntercomAppIdProvider: {
  provide: string;
  useValue: IIntercomAppId;
} = {
  provide: 'intercomAppId',
  useValue: 'hykd9kkf',
};
